import React from 'react';
import { PropTypes } from 'prop-types';
import { LIVECAPTIONS_CONCURRENCY } from '../../../zoom/ZoomConstants';
import LiveCaptionsStackedBar from '../LiveCaptionsStackedBar';

const CONCURRENCY_CONFIG = {
   metric: LIVECAPTIONS_CONCURRENCY,
   title: 'Concurrent Live Captions',
   csvFilename: 'LiveCaptions_Concurrency',
   tooltipText:
      '<div>This chart shows the number of concurrent live captions</div>' +
      '<div>sessions over the selected time period,</div>' +
      '<div>broken down by service (Whisper and Deepgram).</div>',
   getUrl: (start, end, interval) =>
      `/v2/captions/usage/concurrency/timeseries?from=${start.format()}&to=${end.format()}&interval=${interval}`,
   filterUnsupportedMessage: 'Stream and tag filters are not supported for this metric',
   filterUnsupportedCondition: ({ tags, streamNames }) => tags.length > 0 || streamNames.length > 0,
   series: [
      { key: 'whisper', label: 'Whisper', cssVar: '--info' },
      { key: 'deepgram', label: 'Deepgram', cssVar: '--warning' },
   ],
   unitName: 'count',
   processingFn: null,
   formatTotal: (value, isLoadingOrError) => (isLoadingOrError ? 0 : value),
   guardOn204: true,
   labelWidthPx: 80,
   rightPanelMinWidthPx: 190,
   spinnerTopMarginPx: 71,
};

function Concurrency({ height }) {
   return <LiveCaptionsStackedBar height={height} config={CONCURRENCY_CONFIG} />;
}

Concurrency.propTypes = {
   height: PropTypes.number,
};

export default Concurrency;
